var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "documentViewer", staticClass: "document-viewer" }, [
    _c(
      "div",
      { staticClass: "document-viewer__toolbar" },
      [
        _c("q-btn", {
          staticClass: "q-mr-sm",
          attrs: { icon: "add", size: "sm", flat: "", dense: "" },
          on: { click: _vm.handleZoomIn }
        }),
        _c("q-btn", {
          staticClass: "q-mr-sm",
          attrs: { icon: "remove", size: "sm", flat: "", dense: "" },
          on: { click: _vm.handleZoomOut }
        }),
        _c("q-select", {
          staticClass: "q-mr-md",
          attrs: {
            options: _vm.zoomOptions,
            "display-value":
              Math.round(100 * this.zoomFactor).toString() + " %",
            color: "white",
            dark: "",
            "hide-underline": ""
          },
          model: {
            value: _vm.zoomFactor,
            callback: function($$v) {
              _vm.zoomFactor = $$v
            },
            expression: "zoomFactor"
          }
        }),
        _vm.showDownloadButton
          ? _c("q-btn", {
              attrs: {
                icon: "cloud_download",
                size: "sm",
                flat: "",
                dense: ""
              },
              on: { click: _vm.handleDownload }
            })
          : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "document-viewer__content",
        style: { height: _vm.contentHeight }
      },
      [
        !_vm.fileIsLoaded
          ? [_c("q-spinner", { attrs: { color: "white" } })]
          : _vm.fileIsImage
            ? [
                _c(
                  "div",
                  {
                    directives: [
                      { name: "dragscroll", rawName: "v-dragscroll" }
                    ]
                  },
                  [
                    _c("img", {
                      style: { width: _vm.zoom },
                      attrs: { src: _vm.base64 },
                      on: {
                        dragstart: function($event) {
                          $event.preventDefault()
                        }
                      }
                    })
                  ]
                )
              ]
            : _vm.fileIsPdf
              ? [
                  _c(
                    "div",
                    {
                      directives: [
                        { name: "dragscroll", rawName: "v-dragscroll" }
                      ]
                    },
                    _vm._l(_vm.pdfNumPages, function(page) {
                      return _c("pdf", {
                        key: page,
                        staticClass: "document-viewer__pdf-page",
                        style: { width: _vm.zoom },
                        attrs: { src: _vm.pdfSrc, page: page }
                      })
                    })
                  )
                ]
              : [_vm._v("\n      Kann Datei nicht anzeigen\n    ")]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }